import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const res = await fetch(`${API}/auth/google/session`, {
          method: "POST",
          credentials: "include",
          headers: { "X-Session-ID": sessionId },
        });
        if (!res.ok) throw new Error("exchange failed");
        const data = await res.json();
        // For JWT-based existing pages, store the session_token in localStorage so `api` interceptor works
        if (data.session_token) localStorage.setItem("pjp_token", data.session_token);
        setUser(data.user);
        // Clean hash so it isn't reused
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        nav("/login?err=google", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="mono text-sm text-sky">SIGNING YOU IN…</div>
        <div className="eyebrow-muted mt-3">via Google · Emergent Auth</div>
      </div>
    </div>
  );
}
